import { ajax, splitFullname } from "./utils";
import Message from "./Message";
import { updateTrackingInfos } from "./common/UpdateTrackingInfos";
import { initStyleFocusBlur } from "./common/init-melchior-input";
import { clearAllReservedSpotsCountdowns } from "./countdown";
import { scrollEmbedBookingLayoutToTop } from "./embed/scrollEmbedBookingLayoutToTop";

const initStripe = () => {
  console.log('Stripe initialized');

  (async () => {
    'use strict';

    // Create references to the main form and its submit button(s) (embed: desktop + mobile).
    const form = document.getElementById('payment-form');
    const submitButtons = document.querySelectorAll('button[type="submit"][form="payment-form"], button[type="submit"]');
    const submitButton = submitButtons[0] || submitButtons[1] || null;

    const setPaymentSubmitDisabled = (disabled) => {
      submitButtons.forEach((b) => {
        b.disabled = disabled;
      });
    };
    const setPaymentSubmitText = (text) => {
      submitButtons.forEach((b) => {
        b.textContent = text;
      });
    };
    const setPaymentSubmitInnerHTML = (html) => {
      submitButtons.forEach((b) => {
        b.innerHTML = html;
      });
    };
    const amount = parseInt(document.getElementById('checkouta').dataset.amountStripe);
    // const amountFormated = formatPrice('{{ cart.amount_format_payment_request }}', config.currency);
    const fieldsetPayment = document.getElementById('payment-fieldset');
    const confirmationDiv = document.getElementById('confirmation');
    const checkouta = document.getElementById('checkouta');
    const formSelectCountry = form.querySelector('select[name=country]');
    var analyticsUserInfos = {};

    var paymentMethodsSupported;
    if(checkouta.hasAttribute('data-host-currencies-supported')){
      paymentMethodsSupported = JSON.parse(checkouta.dataset.hostCurrenciesSupported);
    } else {
      paymentMethodsSupported = ['card', 'alipay', 'wechat'];
    }
    const stripeDestinationAccount = checkouta.dataset.stripeDestination;

    // Retrieve the configuration for the store.
    const config = {
      // Default country for the checkout form.
      country: formSelectCountry.value,

      paymentRequestCountriesAvailable: [
        'AE', 'AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HK', 'IE', 'IN', 'IT', 'JP', 'LT', 'LU', 'LV', 'MX', 'MY', 'NL', 'NO', 'NZ', 'PH', 'PL', 'PT', 'RO', 'SE', 'SG', 'SI', 'SK', 'US'
      ],

      // Store currency.
      // currency: 'eur',
      currency: checkouta.dataset.currency ?? 'eur',

      // Supported payment methods for the store.
      // Some payment methods support only a subset of currencies.
      // Make sure to check the docs: https://stripe.com/docs/sources
      paymentMethods: paymentMethodsSupported,
      // paymentMethods: [
      //   // 'ach_credit_transfer', // usd (ACH Credit Transfer payments must be in U.S. Dollars)
      //   'alipay', // aud, cad, eur, gbp, hkd, jpy, nzd, sgd, or usd.
      //   // 'bancontact', // eur (Bancontact must always use Euros)
      //   'card', // many (https://stripe.com/docs/currencies#presentment-currencies)
      //   // 'eps', // eur (EPS must always use Euros)
      //   // 'ideal', // eur (iDEAL must always use Euros)
      //   // 'giropay', // eur (Giropay must always use Euros)
      //   // 'multibanco', // eur (Multibanco must always use Euros)
      //   // 'sepa_debit', // Restricted. See docs for activation details: https://stripe.com/docs/sources/sepa-debit
      //   // 'sofort', // eur (SOFORT must always use Euros)
      //   'wechat', // aud, cad, eur, gbp, hkd, jpy, sgd, or usd.
      // ],

      // Configuration for Stripe.
      // API Keys: https://dashboard.stripe.com/account/apikeys
      // Webhooks: https://dashboard.stripe.com/account/webhooks
      // Storing these keys and secrets as environment variables is a good practice.
      // You can fill them in your own `.env` file.
      stripe: {
        // The two-letter country code of your Stripe account (required for Payment Request).
        country: 'FR',
        // API version to set for this app (Stripe otherwise uses your default account version).
        // apiVersion: '2019-03-14',
        // Use your test keys for development and live keys for real charges in production.
        // For non-card payments like iDEAL, live keys will redirect to real banking sites.
        publishableKey: checkouta.dataset.stripePublishKey,
        // secretKey: '',
        // Setting the webhook secret is good practice in order to verify signatures.
        // After creating a webhook, click to reveal details and find your signing secret.
        // webhookSecret: process.env.STRIPE_WEBHOOK_SECRET,
      },
    };

    const formatPrice = (amount, currency) => {
      let price = (amount / 100).toFixed(2);
      let numberFormat = new Intl.NumberFormat(['en-US'], {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
      });
      return numberFormat.format(price);
    };

    // Asynchronous on purpose: host sites embedding the widget may set `Permissions-Policy: sync-xhr=()`.
    const getPaymentIntent = () => new Promise((resolve) => {
      let xmlhttp = new XMLHttpRequest();

      xmlhttp.onreadystatechange = function() {
        if (this.readyState === XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
          if (xmlhttp.status === 200) {
            resolve(JSON.parse(this.responseText));
            return;
          }
          else if (xmlhttp.status === 400) {
            console.error('There was an error 400');
          }
          else {
            console.error('something else other than 200 was returned');
          }

          resolve(undefined);
        }
      };

      const getParam = checkouta.hasAttribute('data-host-id') ? `?host_id=${checkouta.dataset.hostId}`
                                                              : '';

      xmlhttp.open("GET", checkouta.dataset.paymentIntentUrl + getParam);
      xmlhttp.setRequestHeader("X-CSRF-Token", document.querySelector('meta[name="csrfToken"]')?.content);
      xmlhttp.send();
    });

    const paymentIntent = await getPaymentIntent();

    // Global variable to store the PaymentIntent object.
    // let paymentIntent;

    /**
     * Setup Stripe Elements.
     */

      // Create a Stripe client.
    const stripe = Stripe(config.stripe.publishableKey);

    // Create an instance of Elements.
    const elements = stripe.elements();

    // Prepare the styles for Elements.
    const style = {
      base: {
        // iconColor: '#666ee8',
        // color: '#31325f',
        // fontWeight: 400,
        fontFamily: 'Averta, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
            color: '#a0aec0',
        },
        // ':-webkit-autofill': {
        //     color: '#666ee8',
        // },
      },
    };

    /**
     * Implement a Stripe Card Element that matches the look-and-feel of the app.
     *
     * This makes it easy to collect debit and credit card payments information.
     */

    // ? ------------------ Card number -------------------------
    var cardNumber = elements.create('cardNumber', {
      style: style,
      showIcon: true
      // classes: elementClasses,
    });
    cardNumber.mount('#card-number-element');

    // Add style for card number on focus and blur
    const cardNumberElement = document.getElementById('card-number-element');
    initStyleFocusBlur(cardNumber, cardNumberElement);

    // ? ------------------ Card expiry -------------------------
    var cardExpiry = elements.create('cardExpiry', {
      style: style,
      // classes: elementClasses,
    });
    cardExpiry.mount('#card-expiry-element');

    // Add style for card expiry on focus and blur
    const cardExpiryElement = document.getElementById('card-expiry-element');
    initStyleFocusBlur(cardExpiry, cardExpiryElement);

    // ? ------------------ Card cvc -------------------------
    var cardCvc = elements.create('cardCvc', {
      style: style,
      // classes: elementClasses,
    });
    cardCvc.mount('#card-cvc-element');

    // Add style for card cvc on focus and blur
    const cardCvcElement = document.getElementById('card-cvc-element');
    initStyleFocusBlur(cardCvc, cardCvcElement);

    // Create a Card Element and pass some custom styles to it.
    // const card = elements.create('card', {style});

    // Mount the Card Element on the page.
    // card.mount('#card-element');

    // Monitor change events on the Card Element to display any errors.
    cardNumber.on('change', ({error, complete}) => {
      const cardErrors = document.getElementById('card-number-error');
      if (error) {
        cardErrors.textContent = error.message;
        cardErrors.classList.add('visible');
      } else {
        cardErrors.classList.remove('visible');
      }
      // Re-enable the Pay button.
      setPaymentSubmitDisabled(false);

      if(complete){
        cardExpiry.focus();
      }
    });

    cardExpiry.on('change', ({error, complete}) => {
      const cardErrors = document.getElementById('card-expiry-error');
      if (error) {
        cardErrors.textContent = error.message;
        cardErrors.classList.add('visible');
      } else {
        cardErrors.classList.remove('visible');
      }
      // Re-enable the Pay button.
      setPaymentSubmitDisabled(false);

      if(complete){
        cardCvc.focus();
      }
    });

    cardCvc.on('change', () => {
      setPaymentSubmitDisabled(false);
    });

    /**
     * Implement a Stripe IBAN Element that matches the look-and-feel of the app.
     *
     * This makes it easy to collect bank account information.
     */

    // Create a IBAN Element and pass the right options for styles and supported countries.
    if(config.paymentMethods.indexOf('sepa_debit') !== -1) {
      const ibanOptions = {
        style,
        supportedCountries: ['SEPA'],
      };
      const iban = elements.create('iban', ibanOptions);

      // Mount the IBAN Element on the page.
      iban.mount('#iban-element');

      // Monitor change events on the IBAN Element to display any errors.
      iban.on('change', ({error, bankName}) => {
        const ibanErrors = document.getElementById('iban-errors');
        if (error) {
          ibanErrors.textContent = error.message;
          ibanErrors.classList.add('visible');
        } else {
          ibanErrors.classList.remove('visible');
          if (bankName) {
            updateButtonLabel('sepa_debit', bankName);
          }
        }
        // Re-enable the Pay button.
        setPaymentSubmitDisabled(false);
      });
    }

    /**
     * Add an iDEAL Bank selection Element that matches the look-and-feel of the app.
     *
     * This allows you to send the customer directly to their iDEAL enabled bank.
     */

    // Create a iDEAL Bank Element and pass the style options, along with an extra `padding` property.
    if(config.paymentMethods.indexOf('ideal') !== -1) {
      const idealBank = elements.create('idealBank', {
        style: {base: Object.assign({padding: '10px 15px'}, style.base)},
      });

      // Mount the iDEAL Bank Element on the page.
      idealBank.mount('#ideal-bank-element');
    }

    /**
     * Implement a Stripe Payment Request Button Element.
     *
     * This automatically supports the Payment Request API (already live on Chrome),
     * as well as Apple Pay on the Web on Safari, Google Pay, and Microsoft Pay.
     * When of these two options is available, this element adds a “Pay” button on top
     * of the page to let users pay in just a click (or a tap on mobile).
     */

    // Make sure all data is loaded from the store to compute the payment amount.
    // await store.loadProducts();

    // console.log(paymentIntent);
    // Create the payment request.
    if(config.paymentRequestCountriesAvailable.indexOf(config.country) !== -1 && paymentIntent) {
      const paymentRequest = stripe.paymentRequest({
        country: config.country,
        currency: config.currency,
        total: {
          label: paymentIntent.description,
          amount: paymentIntent.amount,
        },
        // requestShipping: true,
        requestPayerName: true,
        requestPayerEmail: true,
        requestPayerPhone: true
        // shippingOptions: config.shippingOptions,
      });

      // Callback when a payment method is created.
      paymentRequest.on('paymentmethod', async event => {
        console.log('stripe confirm payment intent');

        //create a guest user if guest checkout
        if(checkouta.hasAttribute('data-guest-checkout')){
          await createGuestUser(event);
          // if(!createUser) return false;

          //if a discount code is applied, check all restrictions linked to the user
          const checkValidity = await checkUserRelatedDiscountValidity(event);
          if(!checkValidity){
            event.complete('fail');
            return false;
          }
        }

        clearAllReservedSpotsCountdowns();

        //hide the reserved spot countdown
        if(checkouta.hasAttribute('data-cart-id') && checkouta.dataset.cartId !== 'false'){
          // setPaymentSentOnReservedSpots();

          const bookingHeldElts = document.querySelectorAll('.booking-held-wrapper');
          if(bookingHeldElts) bookingHeldElts.forEach(elt => elt.classList.add('hidden'));
        }

        // Confirm the PaymentIntent with the payment method returned from the payment request.
        const {error} = await stripe.confirmPaymentIntent(
          paymentIntent.client_secret,
          {
            payment_method: event.paymentMethod.id,
            // shipping: {
            //     name: event.shippingAddress.recipient,
            //     address: {
            //         line1: event.shippingAddress.addressLine[0],
            //         city: event.shippingAddress.city,
            //         postal_code: event.shippingAddress.postalCode,
            //         state: event.shippingAddress.region,
            //         country: event.shippingAddress.country,
            //     },
            // },
          }
        );
        if (error) {
          console.log('error', error);
          // Report to the browser that the payment failed.
          event.complete('fail');
          handlePayment({error});
        } else {
          console.log('no error Stripe handleCardPayment');
          // Report to the browser that the confirmation was successful, prompting
          // it to close the browser payment method collection interface.
          event.complete('success');

          //update cookies & gtm state to cart
          try{
            if(checkouta.hasAttribute('data-tracking-type')
                && checkouta.hasAttribute('data-tracking-cart-id')
                && checkouta.hasAttribute('data-tracking-update-infos-url'))
            {
              updateTrackingInfos(
                checkouta.dataset.trackingType,
                checkouta.dataset.transactionId,
                checkouta.dataset.trackingUpdateInfosUrl
              );
            }
          } catch(e){
            console.error(e);
          }

          //indicate that the payment was sent on the reserved spots row in DB
          // if(checkouta.hasAttribute('data-cart-id') && checkouta.dataset.cartId !== 'false'){
          //   await setPaymentSentOnReservedSpots();

          //   const bookingHeldElts = document.querySelectorAll('.booking-held-wrapper');
          //   if(bookingHeldElts) bookingHeldElts.forEach(elt => elt.classList.add('hidden'));
          // }

          // Let Stripe.js handle the rest of the payment flow, including 3D Secure if needed.
          const response = await stripe.handleCardPayment(
            paymentIntent.client_secret
          );
          handlePayment(response);
        }
      });

      // Create the Payment Request Button.
      const paymentRequestButton = elements.create('paymentRequestButton', {
        paymentRequest,
      });

      // Check if the Payment Request is available (or Apple Pay on the Web).
      const paymentRequestSupport = await paymentRequest.canMakePayment();
      if (paymentRequestSupport) {
        let paymentRequestButtonEl = document.getElementById('payment-request-button');
        if(paymentRequestButtonEl) {
          // Display the Pay button by mounting the Element in the DOM.
          paymentRequestButton.mount('#payment-request-button');
          // Replace the instruction.
          document.querySelector('div.instruction').classList.remove('hidden');
          // Show the payment request section.
          document.getElementById('payment-request').classList.add('visible');
        }
      }
    }

    /**
     * Handle the form submission.
     *
     * This uses Stripe.js to confirm the PaymentIntent using payment details collected
     * with Elements.
     *
     * Please note this form is not submitted when the user chooses the "Pay" button
     * or Apple Pay, Google Pay, and Microsoft Pay since they provide name and
     * shipping information directly.
     */

    // Listen to changes to the user-selected country.
    formSelectCountry
      .addEventListener('change', event => {
        event.preventDefault();
        selectCountry(event.target.value);
      });


    // Submit handler for our payment form.
    form.addEventListener('submit', async event => {
      event.preventDefault();

      if(!form.checkValidity()) {
        return false;
      }

      //update cookies & gtm state to cart
      try{
        if(checkouta.hasAttribute('data-tracking-type')
            && checkouta.hasAttribute('data-tracking-cart-id')
            && checkouta.hasAttribute('data-tracking-update-infos-url'))
        {
          updateTrackingInfos(
            checkouta.dataset.trackingType,
            checkouta.dataset.transactionId,
            checkouta.dataset.trackingUpdateInfosUrl
          );
        }
      } catch(e){
        console.error(e);
      }

      //create a guest user if guest checkout
      if(checkouta.hasAttribute('data-guest-checkout')){
        await createGuestUser();
        // if(!createUser) return false;

        //if a discount code in guest checkout is applied, check all restrictions linked to the user
        const checkValidity = await checkUserRelatedDiscountValidity();
        if(!checkValidity) return false;
      }
      else{
        updateUserProfile();
      }

      clearAllReservedSpotsCountdowns();

      //hide the reserved spot countdown
      if(checkouta.hasAttribute('data-cart-id') && checkouta.dataset.cartId !== 'false'){
        // setPaymentSentOnReservedSpots();

        const bookingHeldElts = document.querySelectorAll('.booking-held-wrapper');
        if(bookingHeldElts) bookingHeldElts.forEach(elt => elt.classList.add('hidden'));
      }

      // Retrieve the user information from the form.
      const payment = form.querySelector('input[name=payment]:checked').value;
      const name = form.querySelector('input[name=firstname]').value + ' ' + form.querySelector('input[name=lastname]').value;
      const phone = form.querySelector('input[name=phone]').value;
      const country = form.querySelector('select[name=country] option:checked')
        .value;

      const emailInput = form.querySelector('input[name=mail]');
      let email = '';
      if(emailInput){
        email = emailInput.value;
      }

      // Disable the Pay button to prevent multiple click events.
      setPaymentSubmitDisabled(true);
      const processingText = submitButton && submitButton.hasAttribute('data-processing-text')
        ? submitButton.dataset.processingText
        : 'Processing...';
      setPaymentSubmitText(processingText);

      if (payment === 'card') {
        // Let Stripe.js handle the confirmation of the PaymentIntent with the card Element.
        const params = {
          payment_method: {
            card: cardNumber,
            billing_details: {
              name: name,
              phone: phone
            }
          }
        };

        if(email !== ''){
          params.payment_method.billing_details.email = email;
        }

        const response = await stripe.confirmCardPayment(paymentIntent.client_secret, params);
        handlePayment(response);
      } else if (payment === 'sepa_debit') {
        // Confirm the PaymentIntent with the IBAN Element and additional SEPA Debit source data.
        const params = {
          type: 'sepa_debit',
          currency: 'eur',
          owner: {
            name: name,
          },
          mandate: {
            // Automatically send a mandate notification email to your customer
            // once the source is charged.
            notification_method: 'email',
          },
          metadata: {
            paymentIntent: paymentIntent.id,
          },
        };

        if(email !== ''){
          params.owner.email = email;
        }

        const {error} = await stripe.createSource(iban, params);
        if (error) {
          handlePayment({error});
          return;
        }
        // Poll the PaymentIntent status.
        pollPaymentIntentStatus(paymentIntent.id);
      }
      else if (payment === 'alipay'){
        stripe.confirmAlipayPayment(paymentIntent.client_secret, {
          // Return URL where the customer should be redirected to after payment
          return_url: window.location.href,
        }).then((result) => {
          if (result.error) {
            // Inform the customer that there was an error.
            mainElement.classList.remove('success');
            mainElement.classList.remove('processing');
            mainElement.classList.remove('receiver');
            mainElement.classList.add('error');
          }
        });
      }
      else {
        // Prepare all the Stripe source common data.
        const params = {
          type: payment,
          amount: paymentIntent.amount,
          currency: paymentIntent.currency,
          owner: {
            name: name,
            phone: phone
          },
          redirect: {
            return_url: window.location.href,
          },
          statement_descriptor: 'Stripe Payments Demo',
          metadata: {
            paymentIntent: paymentIntent.id,
          },
          on_behalf_of: stripeDestinationAccount
        };

        if(email !== ''){
          params.owner.email = email;
        }

        const sourceData = params;

        // Add extra source information which are specific to a payment method.
        switch (payment) {
          case 'ideal':
            // iDEAL: Add the selected Bank from the iDEAL Bank Element.
            const {source} = await stripe.createSource(idealBank, sourceData);
            handleSourceActivation(source);
            return;
            break;
          case 'sofort':
            // SOFORT: The country is required before redirecting to the bank.
            sourceData.sofort = {
              country,
            };
            break;
          case 'ach_credit_transfer':
            // ACH Bank Transfer: Only supports USD payments, edit the default config to try it.
            // In test mode, we can set the funds to be received via the owner email.
            sourceData.owner.email = `amount_${paymentIntent.amount}@example.com`;
            break;
        }

        // Create a Stripe source with the common data and extra information.
        const {source} = await stripe.createSource(sourceData);
        handleSourceActivation(source);
      }
      // }
    });

    const updateUserProfile = () => {
      let formData = new FormData();
      formData.append('phone', form.querySelector("input[name=phone]").value);
      formData.append('country_iso', form.querySelector("select[name=country]").value);
      formData.append('firstname', form.querySelector('input[name=firstname]').value);
      formData.append('lastname', form.querySelector('input[name=lastname]').value);

      //date of birth
      const dobDay = form.querySelector('input[name=dob_day]');
      const dobMonth = form.querySelector('input[name=dob_month]');
      const dobYear = form.querySelector('input[name=dob_year]');
      if(dobDay && dobMonth && dobYear){
        formData.append('birth_day', dobDay.value);
        formData.append('birth_month', dobMonth.value);
        formData.append('birth_year', dobYear.value);
      }

      ajax(form.dataset.updateProfile, () => {
        console.log('profil updated');
      }, 'POST', formData, {
        "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
      }, true, false);
    };

    const updateBillingAddress = () => {
      const billingForm = document.getElementById('billing-address-form');
      if(billingForm){
        let formData = new FormData();
        const billingCheckbox = billingForm.querySelector("input[name='billing-different']:checked");
        formData.append('billing-different', billingCheckbox ? 'no' : 'yes');
        formData.append('billing[firstname]', billingForm.querySelector("input[name='billing[firstname]']").value);
        formData.append('billing[lastname]', billingForm.querySelector("input[name='billing[lastname]']").value);
        formData.append('billing[address_line_1]', billingForm.querySelector("input[name='billing[address_line_1]']").value);
        formData.append('billing[address_line_2]', billingForm.querySelector("input[name='billing[address_line_2]']").value);
        formData.append('billing[zip]', billingForm.querySelector("input[name='billing[zip]']").value);
        formData.append('billing[city]', billingForm.querySelector("input[name='billing[city]']").value);
        formData.append('billing[country_id]', billingForm.querySelector("select[name='billing[country_id]']").value);
        formData.append('cart_id', billingForm.dataset.cartId);

        ajax(billingForm.dataset.url, () => {
          console.log('billing adress updated');
        }, 'POST', formData, {
          "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
        }, true, false);
      }
    }

    //if a discount code is applied, check all restrictions linked to the user
    const checkUserRelatedDiscountValidity = (dataFromOneClickCheckout = null) => {
      return new Promise(resolve => {
        if(checkouta.hasAttribute('data-discount-code-for-check') && checkouta.dataset.discountCodeForCheck !== 'false'){
          let formData = new FormData();

          const mailInput = form.querySelector("#input-email");
          const discountCode = checkouta.dataset.discountCodeForCheck;
          if((mailInput && discountCode) || dataFromOneClickCheckout !== null){
            if(dataFromOneClickCheckout !== null) var email = dataFromOneClickCheckout.payerEmail;
            else var email = mailInput.value;

            formData.append('email', email);
            formData.append('discountCode', discountCode);

            const initialButtonHtml = submitButton ? submitButton.innerHTML : '';
            setPaymentSubmitText(submitButton.dataset.checkingDiscountValidity);
            setPaymentSubmitDisabled(true);
            ajax(form.dataset.checkUserRelatedDiscountValidityUrl, (data) => {
              if(!data.validity){
                Message.error(data.message);
                setPaymentSubmitDisabled(false);
              }

              setPaymentSubmitInnerHTML(initialButtonHtml);
              resolve(data.validity);
            }, 'POST', formData, {
              "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
            }, true, true);
          }
        }
        else{
          resolve(true);
        }
      });
    }

    //in case it is a guest checkout, create a guest user with all
    const createGuestUser = (dataFromOneClickCheckout = null) => {
      return new Promise(resolve => {
        let formData = new FormData();

        const firstnameInput = form.querySelector('input[name=firstname]');
        const lastnameInput = form.querySelector('input[name=lastname]');
        const phoneInput = form.querySelector('input[name=phone]');
        const emailInput = form.querySelector('input[name=mail]');
        const countryInput = form.querySelector('select[name=country]');
        const langId = checkouta.dataset.langId;
        const origin = checkouta.dataset.type === 'booking' || checkouta.dataset.type === 'giftCard' ? 'website' : 'widget';
        if((firstnameInput && lastnameInput && phoneInput && emailInput && countryInput && langId && origin) || dataFromOneClickCheckout !== null){
          if(dataFromOneClickCheckout !== null){
            let fullname = splitFullname(dataFromOneClickCheckout.payerName);

            var firstname = fullname.firstName;
            var lastname = fullname.lastName;
            var phone = dataFromOneClickCheckout.payerPhone;
            var email = dataFromOneClickCheckout.payerEmail;
            var country = dataFromOneClickCheckout.paymentMethod.billing_details.address.country;
          }
          else{
            var firstname = firstnameInput.value;
            var lastname = lastnameInput.value;
            var phone = phoneInput.value;
            var email = emailInput.value;
            var country = countryInput.value;
          }

          formData.append('firstname', firstname);
          formData.append('lastname', lastname);
          formData.append('phone', phone);
          formData.append('email', email);
          formData.append('country_iso', country);
          formData.append('langId', langId);
          formData.append('origin', origin);
          formData.append('stripeId', paymentIntent.id);
          if(checkouta.hasAttribute('data-host-id')){
            formData.append('hostId', checkouta.dataset.hostId);
          }

          if(checkouta.hasAttribute('data-transaction-id')){
            formData.append('transactionId', checkouta.dataset.transactionId);
          }

          //date of birth
          const dobDay = form.querySelector('input[name=dob_day]');
          const dobMonth = form.querySelector('input[name=dob_month]');
          const dobYear = form.querySelector('input[name=dob_year]');
          if(dobDay && dobMonth && dobYear){
            formData.append('birth_day', dobDay.value);
            formData.append('birth_month', dobMonth.value);
            formData.append('birth_year', dobYear.value);
          }

          if(dataFromOneClickCheckout !== null){
            formData.append('newsletter', true);
          }
          else{
            const newsletter = form.querySelector('input[name=newsletter]');
            if(newsletter) formData.append('newsletter', newsletter.checked);
          }

          const hostEmailCommunicationCheckbox = form.querySelector('[data-host-email-communication-checkbox]');
          if(hostEmailCommunicationCheckbox){
            formData.append('accepts_host_email_communication', hostEmailCommunicationCheckbox.checked);
          }

          setPaymentSubmitDisabled(true);
          ajax(form.dataset.createGuestUserUrl, (data) => {
            analyticsUserInfos.userId = data.userId;
            analyticsUserInfos.returningUser = data.returningUser;
            analyticsUserInfos.newsletter = data.newsletter;

            resolve(data.success);
          },
          'POST', formData, {}, true, true);
        }
        else{
          resolve(false);
        }
      });
    }

    //in case it is not a guest checkout, get user infos for GA4 Analytics
    const getUserAnalyticsInfo = (dataFromOneClickCheckout = null) => {
      return new Promise(resolve => {
        const emailInput = form.querySelector('input[name=mail]');
        if(emailInput || dataFromOneClickCheckout !== null){
          if(dataFromOneClickCheckout !== null){
            var email = dataFromOneClickCheckout.payerEmail;
          }
          else{
            var email = emailInput.value;
          }

          const transactionId = checkouta.dataset.transactionId || '';
          ajax(form.dataset.getUserInfosUrl + '?email=' + email + '&transaction_id=' + encodeURIComponent(transactionId), (data) => {
            analyticsUserInfos.userId = data.userId;
            analyticsUserInfos.returningUser = data.returningUser;
            analyticsUserInfos.newsletter = data.newsletter;

            resolve(data.success);
          },
          'GET', {}, {}, false, true);
        }
        else{
          resolve(false);
        }
      });
    }

    const setPaymentSentOnReservedSpots = () => {
      return new Promise(resolve => {
        let formData = new FormData();

        const cartId = checkouta.dataset.cartId;
        if(cartId) formData.append('cart_id', cartId);
        // proves the request comes from the checkout of this cart
        if(checkouta.dataset.transactionId) formData.append('transaction_id', checkouta.dataset.transactionId);

        setPaymentSubmitDisabled(true);
        ajax(form.dataset.setPaymentSentUrl, (data) => {
          resolve(data.success);
        },
        'POST', formData, {}, false, true);
      });
    }


    const clearCartInServerSession = () => {
      console.log('clearCartInServerSession');
      let xmlhttp = new XMLHttpRequest();

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState === XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
          if (xmlhttp.status === 200) {
            console.log('cart cleared');
          }
          else if (xmlhttp.status === 400) {
            console.error('There was an error 400');
          }
          else {
            console.error('something else other than 200 was returned');
          }
        }
      };

      xmlhttp.open("GET", form.dataset.clearCartUrl);
      xmlhttp.setRequestHeader("X-CSRF-Token", document.querySelector('meta[name="csrfToken"]')?.content);
      xmlhttp.send();
    };

    // Facebook API Conversion request
    const sendFacebookAPIConversionRequest = () => {
      if(checkouta.dataset.type == 'booking' || checkouta.dataset.type == 'widget'){
        let formData = new FormData();
        const eventId = checkouta.dataset.facebookPurchaseEventId;
        formData.append('event_id', eventId);

        const facebookData = document.getElementById('facebook-data');
        if(facebookData){
          formData.append('value', facebookData.dataset.value);

          const paymentType = checkouta.dataset.checkoutType;
          if(paymentType === 'payment-link'){
            formData.append('payment_link', true);
            formData.append('experience_name', facebookData.dataset.experienceName);
            formData.append('experience_id', facebookData.dataset.experienceId);
          }
        }

        formData.append('mail', form.querySelector("input[name=mail]")?.value);
        formData.append('phone', form.querySelector("input[name=phone]")?.value);
        formData.append('country_iso', form.querySelector("select[name=country]")?.value);
        formData.append('firstname', form.querySelector('input[name=firstname]')?.value);
        formData.append('lastname', form.querySelector('input[name=lastname]')?.value);

        ajax(form.dataset.facebookUrl, () => {}, 'POST', formData, {
          "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
        }, true, false);
      }
      else if(checkouta.dataset.type == 'giftCard'){
        let formData = new FormData();

        const eventId = checkouta.dataset.facebookPurchaseEventId;
        formData.append('event_id', eventId);
        formData.append('value', checkouta.dataset.value);
        formData.append('mail', form.querySelector("input[name=mail]")?.value);
        formData.append('phone', form.querySelector("input[name=phone]")?.value);
        formData.append('country_iso', form.querySelector("select[name=country]")?.value);
        formData.append('firstname', form.querySelector('input[name=firstname]')?.value);
        formData.append('lastname', form.querySelector('input[name=lastname]')?.value);


        ajax(form.dataset.facebookUrl, () => {}, 'POST', formData, {
          "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
        }, false, false);
      }
    }

    // Google Ecommerce Analytics
    const setupGoogleAnalytics = () => {
      if (typeof dataLayer != 'undefined') {
        let email = '/';
        let buyerPhone = '/';
        let buyerCountry = '/';
        if(form){
          let emailInput = form.querySelector('input[name=mail]');
          if(emailInput) email = emailInput.value;

          let phoneInput = form.querySelector('input[name=phone]')
          if(phoneInput) buyerPhone = phoneInput.value;

          let countryInput = form.querySelector('select[name=country] option:checked');
          if(countryInput) buyerCountry = countryInput.value;
        }

        dataLayer.push({
          'price': amount / 100, // stripe payment amount
          'orderid': checkouta.dataset.transactionId, // stripe payment ID, not winalist order ID
          'stripe_id': paymentIntent.id, // stripe payment ID, not winalist order ID
          'eventLabel': checkouta.dataset.type,
        });

        dataLayer.push({
          'event': 'EEtransaction',
          'eventLabel': checkouta.dataset.type,
          'ecommerce': {
            'currencyCode': config.currency.toUpperCase(),
            'purchase': {
              'actionField': {
                'id': paymentIntent.id,
                'affiliation': window.location.hostname,
                'revenue': amount / 100,
                'tax': '0.00',
                'shipping': '0.00'
              },
              'products': [{
                'name': '{{ cart.experience.name }}',
                'id': '{{ cart.experience.id }}',
                'price': '{{ cart.amount / 100 }}',
                'brand': '{{ cart.experience.host.name }}',
                'category': 'Experience',
                'quantity': 1
              }]
            }
          }
        });

        dataLayer.push({
          'event': 'EEcheckout',
          'ecommerce': {
            'checkout': {
              'actionField': {'step': 3},
            }
          }
        });

        //GA4 - Experience purchase
        try{
          const expAnalyticsBlock = document.getElementById('experience-data');
          if(expAnalyticsBlock){
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
              event: "purchase",
              ecommerce: {
                transaction_id: paymentIntent.id,
                currency: expAnalyticsBlock.dataset.hostCurrency,
                value: expAnalyticsBlock.dataset.amount,
                items: [{
                  item_id: expAnalyticsBlock.dataset.experienceId,
                  item_name: expAnalyticsBlock.dataset.experienceName,
                  currency: expAnalyticsBlock.dataset.hostCurrency,
                  item_brand: expAnalyticsBlock.dataset.hostName,
                  item_category: expAnalyticsBlock.dataset.categoryOne,
                  item_category2: expAnalyticsBlock.dataset.categoryTwo,
                  item_category3: expAnalyticsBlock.dataset.categoryThree,
                  item_category4: expAnalyticsBlock.dataset.categoryFour,
                  quantity: 1
                }]
              },
              buyer_email: email,
              buyer_phone: buyerPhone,
              buyer_country: buyerCountry,
              buyer_id: Object.keys(analyticsUserInfos).length !== 0 ? analyticsUserInfos.userId : '/',
              returning_user: Object.keys(analyticsUserInfos).length !== 0 ? analyticsUserInfos.returningUser : '/',
              newsletter: Object.keys(analyticsUserInfos).length !== 0 ? analyticsUserInfos.newsletter : '/'
            });

            let dataObject = {
              'event': 'checkout_success',
              'category': 'page',
              'label': 'label_checkout_success',
              'buyer_email': email,
              'buyer_phone': buyerPhone,
              'buyer_country': buyerCountry,
              'buyer_id': Object.keys(analyticsUserInfos).length !== 0 ? analyticsUserInfos.userId : '/',
              'returning_user': Object.keys(analyticsUserInfos).length !== 0 ? analyticsUserInfos.returningUser : '/',
              'newsletter': Object.keys(analyticsUserInfos).length !== 0 ? analyticsUserInfos.newsletter : '/'
            };

            dataLayer.push(dataObject);
          }
        } catch(e){
          console.error(e);
        }

        //GA4 - GC purchase
        try{
          const gcAnalyticsBlock = document.getElementById('gift-card-data');
          if(gcAnalyticsBlock){
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
              event: "purchase",
              ecommerce: {
                currency: 'EUR',
                value: gcAnalyticsBlock.dataset.amount,
                items: [{
                  item_id: gcAnalyticsBlock.dataset.experienceId,
                  item_name: gcAnalyticsBlock.dataset.type,
                  currency: 'EUR',
                  item_brand: gcAnalyticsBlock.dataset.hostName,
                  item_category: gcAnalyticsBlock.dataset.categoryOne,
                  item_category2: gcAnalyticsBlock.dataset.categoryTwo,
                  item_category3: gcAnalyticsBlock.dataset.categoryThree,
                  item_category4: gcAnalyticsBlock.dataset.categoryFour,
                  quantity: 1
                }]
              }
            });
          }
        } catch(e){
          console.error(e);
        }
      }
    }

    const checkoutSuccess = () => {
      //on the widget, just show message indicating the checkout was successful
      if(checkouta.dataset.type === 'widget'){
        widgetCheckoutSuccess();
      }

      //finalize transaction (clear cart, analytics, etc...)
      finalizeTransactionProcess();

      //redirect to the thank you page (if not on widget)
      if(checkouta.dataset.type === 'booking' || checkouta.dataset.type === 'giftCard'){
        window.location.replace(checkouta.dataset.thankYouUrl);
      }
    }

    const widgetCheckoutSuccess = () => {
      // Success! Payment is confirmed. Update the interface to display the confirmation screen.
      mainElement.classList.remove('processing');
      mainElement.classList.remove('receiver');
      // Update the note about receipt and shipping (the payment has been fully confirmed by the bank).
      // confirmationElement.querySelector('.note').innerText =
      //     'We just sent your receipt to your email address, and your items will be on their way shortly.';
      mainElement.classList.add('success');
      let cart_informations = document.querySelector('.booking-cart .informations');
      if(cart_informations){
        cart_informations.classList.add('hidden');
      }

      //for embed/iframe booking
      let topBookingInformations = document.getElementById('top-booking-informations');
      let payAndConfirm = document.getElementById('payAndConfirm');
      if(topBookingInformations && payAndConfirm){
        topBookingInformations.classList.add('hidden');
        payAndConfirm.textContent = payAndConfirm.dataset.bookingConfirmation;
      }

      // hide elements that should be hidden
      const elementsToHide = document.querySelectorAll('.hide-on-checkout-success');
      if(elementsToHide){
        elementsToHide.forEach(element => {
          element.classList.add('hidden');
          element.classList.add('lg:hidden');
        });
      }

      const showOnCheckoutSuccess = document.querySelectorAll('.show-on-checkout-success');
      if(showOnCheckoutSuccess){
        showOnCheckoutSuccess.forEach(element => {
          element.classList.remove('hidden');
        });
      }

      // and narrow the modal container to make a nice animation
      // const modalContainer = mainElement.closest('.modal-container');
      // const modalContent = mainElement.closest('.modal-content');
      // if(modalContainer && modalContent) {
      //   modalContainer.classList.remove('max-w-8xl');
      //   modalContainer.classList.add('max-w-2xl');
      //   modalContent.classList.remove('max-w-8xl');
      //   modalContent.classList.add('max-w-2xl');
      // }

      let partnerTopBar = document.getElementById('partner-top-bar');
      if(partnerTopBar) partnerTopBar.classList.add('hidden');
      // document.querySelector('.booking-cart .informations').classList.add('hidden');

      let imageCheers = document.getElementById('cheers-image');
      if(imageCheers) {
        imageCheers.classList.remove('invisible');
      }

      scrollEmbedBookingLayoutToTop();
    }

    const finalizeTransactionProcess = () => {
      //clear the session cart
      clearCartInServerSession();

      //indicate that the payment was sent on the reserved spots row in DB
      if(checkouta.hasAttribute('data-cart-id') && checkouta.dataset.cartId !== 'false'){
        try{
          setPaymentSentOnReservedSpots();
        } catch(e){
          console.error(e);
        }
      }

      //get user infos before sending event to Google Analytics
      //if guest checkout, these infos are already fetched, otherwise we go get them
      if(Object.keys(analyticsUserInfos).length === 0){
        getUserAnalyticsInfo();
      }

      // Google Ecommerce Analytics
      setupGoogleAnalytics();

      // Facebook API Conversions
      try{
        sendFacebookAPIConversionRequest();
      } catch(e){
        console.error(e);
      }
    }

    // Handle new PaymentIntent result
    const handlePayment = paymentResponse => {
      const {paymentIntent, error} = paymentResponse;

      const mainElement = document.getElementById('main');
      const confirmationElement = document.getElementById('confirmation');

      updateBillingAddress();

      if (error) {
        mainElement.classList.remove('processing');
        mainElement.classList.remove('receiver');
        confirmationElement.querySelector('.error-message').innerText =
          error.message;
        mainElement.classList.add('error');

        const hideOnCheckoutError = document.querySelectorAll('.hide-on-checkout-error');
        if(hideOnCheckoutError){
          hideOnCheckoutError.forEach(element => {
            element.classList.add('force-hide');
          });
        }
      }
      else if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture') {
        checkoutSuccess();
      }
      else {
        // Payment has failed.s
        mainElement.classList.remove('success');
        mainElement.classList.remove('processing');
        mainElement.classList.remove('receiver');
        mainElement.classList.add('error');

        const hideOnCheckoutError = document.querySelectorAll('.hide-on-checkout-error');
        if(hideOnCheckoutError){
          hideOnCheckoutError.forEach(element => {
            element.classList.add('force-hide');
          });
        }
      }

      window.scrollTo(0, 0);
    };

    const retry = () => {
      const mainElement = document.getElementById('main');
      // const confirmationElement = document.getElementById('confirmation');
      init();
      mainElement.classList.remove('error');

      const hideOnCheckoutError = document.querySelectorAll('.hide-on-checkout-error');
      if(hideOnCheckoutError){
        hideOnCheckoutError.forEach(element => {
          element.classList.remove('force-hide');
        });
      }
    };

    // bind retry to retry payment button
    document.getElementById('retry-payment-button').addEventListener('click', retry);

    // Handle activation of payment sources not yet supported by PaymentIntents
    const handleSourceActivation = source => {
      const mainElement = document.getElementById('main');
      const confirmationElement = document.getElementById('confirmation');
      switch (source.flow) {
        case 'none':
          // Normally, sources with a `flow` value of `none` are chargeable right away,
          // but there are exceptions, for instance for WeChat QR codes just below.
          if (source.type === 'wechat') {
            // Display the QR code.
            const qrCode = new QRCode('wechat-qrcode', {
              text: source.wechat.qr_code_url,
              width: 128,
              height: 128,
              colorDark: '#424770',
              colorLight: '#f8fbfd',
              correctLevel: QRCode.CorrectLevel.H,
            });
            // Hide the previous text and update the call to action.
            form.querySelector('.payment-info.wechat p').style.display = 'none';
            // console.log(amount, amountFormated);
            setPaymentSubmitText(submitButton.dataset.wechatScan);
            // Start polling the PaymentIntent status.
            pollPaymentIntentStatus(paymentIntent.id, 300000);
          } else {
            console.log('Unhandled none flow.', source);
          }
          break;
        case 'redirect':
          // Immediately redirect the customer.
          setPaymentSubmitText('Redirecting…');
          window.location.replace(source.redirect.url);
          break;
        case 'code_verification':
          // Display a code verification input to verify the source.
          break;
        case 'receiver':
          // Display the receiver address to send the funds to.
          mainElement.classList.add('success', 'receiver');
          const receiverInfo = confirmationElement.querySelector(
            '.receiver .info'
          );
          // let amount = amount;
          switch (source.type) {
            case 'ach_credit_transfer':
              // Display the ACH Bank Transfer information to the user.
              const ach = source.ach_credit_transfer;
              receiverInfo.innerHTML = `
              <ul>
                <li>
                  Amount:
                  <strong>${amount}</strong>
                </li>
                <li>
                  Bank Name:
                  <strong>${ach.bank_name}</strong>
                </li>
                <li>
                  Account Number:
                  <strong>${ach.account_number}</strong>
                </li>
                <li>
                  Routing Number:
                  <strong>${ach.routing_number}</strong>
                </li>
              </ul>`;
              break;
            case 'multibanco':
              // Display the Multibanco payment information to the user.
              const multibanco = source.multibanco;
              receiverInfo.innerHTML = `
              <ul>
                <li>
                  Amount (Montante):
                  <strong>${amount}</strong>
                </li>
                <li>
                  Entity (Entidade):
                  <strong>${multibanco.entity}</strong>
                </li>
                <li>
                  Reference (Referencia):
                  <strong>${multibanco.reference}</strong>
                </li>
              </ul>`;
              break;
            default:
              console.log('Unhandled receiver flow.', source);
          }
          // Poll the PaymentIntent status.
          pollPaymentIntentStatus(paymentIntent.id);
          break;
        default:
          // Customer's PaymentIntent is received, pending payment confirmation.
          break;
      }
    };

    /**
     * Monitor the status of a source after a redirect flow.
     *
     * This means there is a `source` parameter in the URL, and an active PaymentIntent.
     * When this happens, we'll monitor the status of the PaymentIntent and present real-time
     * information to the user.
     */

    const pollPaymentIntentStatus = async (
      paymentIntent,
      timeout = 30000,
      interval = 500,
      start = null
    ) => {
      start = start ? start : Date.now();
      const endStates = ['succeeded', 'processing', 'canceled'];
      // Retrieve the PaymentIntent status from our server.
      const fetchUrl = checkouta.dataset.paymentIntentStatusUrl;
      const getParam = checkouta.hasAttribute('data-host-id') ? `?host_id=${checkouta.dataset.hostId}`
                                                              : '';
      const rawResponse = await fetch(`${fetchUrl}/${paymentIntent}${getParam}`);
      const response = await rawResponse.json();
      if (
        !endStates.includes(response.paymentIntent.status) &&
        Date.now() < start + timeout
      ) {
        // Not done yet. Let's wait and check again.
        setTimeout(
          pollPaymentIntentStatus,
          interval,
          paymentIntent,
          timeout,
          interval,
          start
        );
      } else {
        handlePayment(response);
        if (!endStates.includes(response.paymentIntent.status)) {
          // Status has not changed yet. Let's time out.
          console.warn(new Error('Polling timed out.'));
        }
      }
    };

    const url = new URL(window.location.href);
    const mainElement = document.getElementById('main');
    if (url.searchParams.get('payment_intent_client_secret') && url.searchParams.get('payment_intent')) {
      // Update the interface to display the processing screen.
      mainElement.classList.add('checkout', 'success', 'processing');

      // const {source} = await stripe.retrieveSource({
      //   id: url.searchParams.get('source'),
      //   client_secret: url.searchParams.get('client_secret'),
      // });

      // console.log(source);
      // Poll the PaymentIntent status.
      pollPaymentIntentStatus(paymentIntent.id);
      // pollPaymentIntentStatus(source.metadata.paymentIntent);
    } else {
      // Update the interface to display the checkout form.
      mainElement.classList.add('checkout');
    }

    document.getElementById('main').classList.remove('loading');

    /**
     * Display the relevant payment methods for a selected country.
     */

      // List of relevant countries for the payment methods supported in this demo.
      // Read the Stripe guide: https://stripe.com/payments/payment-methods-guide
    const paymentMethods = {
        ach_credit_transfer: {
          name: 'Bank Transfer',
          flow: 'receiver',
          countries: ['US'],
          currencies: ['usd'],
        },
        alipay: {
          name: 'Alipay',
          flow: 'redirect',
          countries: ['CN', 'HK', 'SG', 'JP'],
          currencies: [
            'aud',
            'cad',
            'eur',
            'gbp',
            'hkd',
            'jpy',
            'nzd',
            'sgd',
            'usd',
          ],
        },
        bancontact: {
          name: 'Bancontact',
          flow: 'redirect',
          countries: ['BE'],
          currencies: ['eur'],
        },
        card: {
          name: 'Card',
          flow: 'none',
        },
        eps: {
          name: 'EPS',
          flow: 'redirect',
          countries: ['AT'],
          currencies: ['eur'],
        },
        ideal: {
          name: 'iDEAL',
          flow: 'redirect',
          countries: ['NL'],
          currencies: ['eur'],
        },
        giropay: {
          name: 'Giropay',
          flow: 'redirect',
          countries: ['DE'],
          currencies: ['eur'],
        },
        multibanco: {
          name: 'Multibanco',
          flow: 'receiver',
          countries: ['PT'],
          currencies: ['eur'],
        },
        sepa_debit: {
          name: 'SEPA Direct Debit',
          flow: 'none',
          countries: [
            'FR',
            'DE',
            'ES',
            'BE',
            'NL',
            'LU',
            'IT',
            'PT',
            'AT',
            'IE',
            'FI',
          ],
          currencies: ['eur'],
        },
        sofort: {
          name: 'SOFORT',
          flow: 'redirect',
          countries: ['DE', 'AT'],
          currencies: ['eur'],
        },
        wechat: {
          name: 'WeChat',
          flow: 'none',
          countries: ['CN', 'HK', 'SG', 'JP'],
          currencies: [
            'aud',
            'cad',
            'eur',
            'gbp',
            'hkd',
            'jpy',
            'nzd',
            'sgd',
            'usd',
          ],
        },
      };

    // Update the main button to reflect the payment method being selected.
    const updateButtonLabel = (paymentMethod, bankName) => {
      if (!submitButton) {
        return;
      }
      let name = paymentMethods[paymentMethod].name;
      let isBookingAuto = submitButton.dataset.isBookingAuto;
      // console.log(name, isBookingAuto);
      let label = submitButton.dataset.bookingAuto;
      if(isBookingAuto !== '1') {
        // console.log('not booking auto!');
        label = submitButton.dataset.needsConfirmation;
      }
      // let label = `Pay ${amountFormated}`;
      if (paymentMethod !== 'card') {
        // label = `Pay ${amountFormated} with ${name}`;
      }
      if (paymentMethod === 'wechat') {
        label = submitButton.dataset.wechat;
        // `Generate QR code to pay ${amountFormated} with ${name}`;
      }
      if (paymentMethod === 'sepa_debit' && bankName) {
        label = submitButton.dataset.sepaDebit;
        // label = `Debit ${amountFormated} from ${bankName}`;
      }
      submitButtons.forEach((b) => {
        b.innerText = label;
      });
    };

    const selectCountry = country => {
      const selector = form.querySelector('select[name=country]');
      // selector.querySelector(`option[value=${country}]`).selected = 'selected';
      // selector.className = `form-control field ${country}`;
      // selector.classList

      // Trigger the methods to show relevant fields and payment methods on page load.
      // showRelevantFormFields();
      showRelevantPaymentMethods();
    };

    // Show only form fields that are relevant to the selected country.
    // const showRelevantFormFields = country => {
    //     if (!country) {
    //         country = form.querySelector('select[name=country] option:checked').value;
    //     }
    //     // const zipLabel = form.querySelector('div.zip');
    //     // Only show the state input for the United States.
    //     // fieldsetPayment.classList.toggle('with-state', country === 'US');
    //     // Update the ZIP label to make it more relevant for each country.
    //     // form.querySelector('div.zip label').innerText = country === 'US' ? 'ZIP' : country === 'GB' ? 'ZIP code (optional)' : 'ZIP code (optional)';
    //     // form.querySelector('div.zip label').innerText = country === 'US' ? 'ZIP' : country === 'GB' ? '{{ __('ZIP code (optional)') }}' : '{{ __('ZIP code (optional)') }}';
    // };

    // Show only the payment methods that are relevant to the selected country.
    const showRelevantPaymentMethods = country => {
      if (!country) {
        country = form.querySelector('select[name=country] option:checked').value;
      }
      const paymentInputs = form.querySelectorAll('input[name=payment]');
      for (let i = 0; i < paymentInputs.length; i++) {
        let input = paymentInputs[i];
        input.parentElement.classList.toggle(
          'visible',
          input.value === 'card' ||
          (config.paymentMethods.includes(input.value) &&
            paymentMethods[input.value].countries.includes(country) &&
            paymentMethods[input.value].currencies.includes(config.currency))
        );
      }

      // Hide the tabs if card is the only available option.
      const paymentMethodsTabs = document.getElementById('payment-methods');
      paymentMethodsTabs.classList.toggle(
        'visible',
        paymentMethodsTabs.querySelectorAll('li.visible').length > 1
      );

      // Check the first payment option again.
      paymentInputs[0].checked = 'checked';
      form.querySelector('.payment-info.card').classList.add('visible');
      // form.querySelector('.payment-info.ideal').classList.remove('visible');
      // form.querySelector('.payment-info.sepa_debit').classList.remove('visible');
      form.querySelector('.payment-info.wechat').classList.remove('visible');
      form.querySelector('.payment-info.redirect').classList.remove('visible');
      updateButtonLabel(paymentInputs[0].value, undefined, amount);
    };

    // Listen to changes to the payment method selector.
    for (let input of document.querySelectorAll('input[name=payment]')) {
      input.addEventListener('change', event => {
        event.preventDefault();
        const payment = form.querySelector('input[name=payment]:checked').value;
        const flow = paymentMethods[payment].flow;

        // Update button label.
        updateButtonLabel(event.target.value);

        // Show the relevant details, whether it's an extra element or extra information for the user.
        form
          .querySelector('.payment-info.card')
          .classList.toggle('visible', payment === 'card');
        form
          .querySelector('.payment-info.ideal')
          .classList.toggle('visible', payment === 'ideal');
        form
          .querySelector('.payment-info.sepa_debit')
          .classList.toggle('visible', payment === 'sepa_debit');
        form
          .querySelector('.payment-info.wechat')
          .classList.toggle('visible', payment === 'wechat');
        form
          .querySelector('.payment-info.redirect')
          .classList.toggle('visible', flow === 'redirect');
        form
          .querySelector('.payment-info.receiver')
          .classList.toggle('visible', flow === 'receiver');
        // document
        //   .getElementById('card-errors')
        //   .classList.remove('visible', payment !== 'card');

        // const importantNoticeText = document.querySelector(".importantnotice");
        // const captureNoticeText = document.querySelector(".captureNotice");
        const noCaptureNoticeText = document.querySelector(".noCaptureNotice");
        const captureNoticeAfterPaymentText = document.querySelector(".captureNoticeAfterPayment");
        const noCaptureNoticeAfterPaymentText = document.querySelector(".noCaptureNoticeAfterPayment");
        if(noCaptureNoticeText && captureNoticeAfterPaymentText && noCaptureNoticeAfterPaymentText){
          if(payment === 'alipay' || payment === 'wechat'){
            // captureNoticeText.classList.add('hidden');
            noCaptureNoticeText.classList.remove('hidden');

            captureNoticeAfterPaymentText.classList.add('hidden');
            noCaptureNoticeAfterPaymentText.classList.remove('hidden');
          } else {
            // captureNoticeText.classList.remove('hidden');
            noCaptureNoticeText.classList.add('hidden');
          }

          if(payment === 'card'){
            // importantNoticeText.classList.remove('hidden');

            captureNoticeAfterPaymentText.classList.remove('hidden');
            noCaptureNoticeAfterPaymentText.classList.add('hidden');
          } else {
            // importantNoticeText.classList.add('hidden');
          }
        }
      });
    }

    let init = () => {

      // Select the default country from the config on page load.
      let country = config.country;
      // Override it if a valid country is passed as a URL parameter.
      const urlParams = new URLSearchParams(window.location.search);
      let countryParam = urlParams.get('country')
        ? urlParams.get('country').toUpperCase()
        : config.country;
      if (form.querySelector(`option[value="${countryParam}"]`)) {
        country = countryParam;
      }
      selectCountry(country);
    };

    init();
  })();
};

export {initStripe};
